import clsx from 'clsx';
import styles from './stat-table.module.scss';
import DemoBadge from '@/components/demo-badge/demo-badge';
import { StatTableAlign, StatTableRow } from './stat-table.types';

interface StatTableProps {
  columns: string[];
  rows: StatTableRow[];
  /** Index-matched to `columns`. Anything unlisted stays left. */
  align?: StatTableAlign[];
  className?: string;
}

export default function StatTable({ columns, rows, align, className }: StatTableProps) {
  const alignment = (index: number) => align?.[index] === 'right' && styles.alignRight;

  return (
    <table className={clsx(styles.table, className)}>
      <thead>
        <tr>
          {columns.map((column, index) => (
            <th key={column} className={clsx(styles.head, alignment(index))}>
              {column}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, index) => (
          // Index key: two rows may legitimately carry the same label.
          <tr key={`${row.label}-${index}`}>
            <td className={clsx(styles.cell, alignment(0))}>
              {row.label}
              {row.badge && <DemoBadge className={styles.badge} variant={row.badge} />}
            </td>
            {row.values.map((value, valueIndex) => (
              <td
                key={`${value}-${valueIndex}`}
                className={clsx(styles.cell, alignment(valueIndex + 1))}
              >
                {row.positive && valueIndex === 0 ? (
                  <b className={styles.positive}>{value}</b>
                ) : (
                  value
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
